import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { LabelLine } from 'components/InputV2/components';
import services from '../services/Services';
import createToast from 'components/Toast/Toast';
import UploadFiles from 'components/UploadFile';
import useCustomHook from '../hooks';
import { Grid, Button, CircularProgress, Select, MenuItem, InputLabel } from '@mui/material';
import { useStyles } from './style';
import { constBreadCrumbsTitle } from 'utility';
import { initializeConditionalFields, handleFieldChange } from './conditionalFileds';
import {
  PageContainer,
  InputV2,
  ButtonLoading,
  AutocompleteV,
  Icons,
  CustomCaptchaComponent,
} from 'components';
import GenerateField from './GenerateDataField';
import { useNavigate } from 'react-router-dom';
const CreateTicket = () => {
  const {
    baseLoading,
    setBaseLoading,
    filesUpoaded,
    setFilesUpoaded,
    categories,
    setCategories,
    listServices,
    setListServices,
    fields,
    setFields,
    selectedCategory,
    setSelectedCategory,
    selectedService,
    setSelectedService,
    captchaId,
    setCaptchaId,
    enteredCaptcha,
    setEnteredCaptcha,
    submitLoading,
    setSubmitLoading,
    isServiceChangeLoading,
    setIsServiceChangeLoading,
    loadingSupport,
    setLoadingSupport,
  } = useCustomHook();
  const captchaRef = useRef();
  const methods = useForm();
  const navigate = useNavigate();
  const classes = useStyles();
  const { control, register, formState: { errors } } = methods;
  useEffect(() => {
    methods.setValue('captchaAnswer', ' ');
    setEnteredCaptcha('');
    setBaseLoading(true);
    getCategorySale();
  }, []);
  useEffect(() => {
    // مقداری که کاربر کلمه عبور وارد میکند به اجزاری هر تغییر این افکت اجرا میشود - برای اینکه بعد از سرویس خطا که فیلد کد امنیتی خالی میشود، ولیدیشن بصورت صحیح عمل کند
    methods.setValue('captchaAnswer', enteredCaptcha);
  }, [enteredCaptcha]);

  useEffect(() => {
    // حالت خاصی داشتیم که منطقی نبود و زمانیکه نوع برداشت دیافالت واسه پادیوم رو انتخاب میکردیم ، فرم ارور عمل میکرد و عملکردشو بدرستی انجام نمیداد . با این تکه کد رفع ارور کردم
    methods.setValue('service', selectedService);
    methods.clearErrors('service');
  }, [selectedService]);

  /**
   * زمانیکه کمبوباکس بخش مربوطه تغییر میکند این تابع کال میشود
   */
  const onChangeCategory = (c) => {
    setFields([]);
    setSelectedCategory(c);
    setSelectedService('');

    if (c === 'sale') {
      setLoadingSupport(true);
      getTicketFullSale(c);
    } else {
      setLoadingSupport(true);
      getTicketFullSupport(c);
    }
  };
  /**
   * با این تابع ، لیستی آماده میکنیم که کمبوباکس سرویس ها بتوند برستی نمایش دهد
   */
  const makeListService = (projects, category) => {
    setListServices([]);
    let list = projects.map((val) => ({
      id: val?.Id,
      label: val?.Name,
      value: val?.Id,
    }));
    setListServices(list);
    setFields([]);
  };

  const getTicketFullSale = async (c) => {
    await services
      .getTicketFullSale()
      .then((res) => {
        setLoadingSupport(false);
        let projects = res?.result?.projects[0]?.workItemList;
        makeListService(projects, c);
      })
      .catch((error) => {
        setLoadingSupport(false);
      });
  };

  const getTicketFullSupport = async (c) => {
    await services
      .getTicketFullSupport()
      .then((res) => {
        setLoadingSupport(false);
        let projects = res?.result?.projects[0]?.workItemList;
        makeListService(projects, c);
      })
      .catch((error) => {
        setLoadingSupport(false);
      });
  };
  /**
   * وقتی که کمبوباکس سرویس تغییر میکند این تابغ کال میشود
   */
  const onChangeService = (s) => {
    setSelectedService(s);
    setFields([]);

    const cat = categories.find((a) => a.key == selectedCategory);
      // اگر ترو باشد یعنی میتونیم واسش ریکوعست بزنیم
      setIsServiceChangeLoading(true);
      services
        .getTicketWorkItemFields(s?.id, { projectId: cat?.projects[0]?.id })
        .then((res) => {
          let customRes = res?.result;          
          let count = 0;
          for (const item of customRes) {
            item['selectedValue'] = '';
            item['name'] = 'field' + count; // واسه اینکه ولیدیشن روی فیلدهای داینامیک ایجاد بشه ، باید یک نام برای هر المنت ایجاد کنیم
            count++;
            if (item?.type === 'radio') {
              !item['fields'] && (item['fields'] = []); // اگر وجود نداشته باشد لیست کمبوباکس، بصورت دستی بهش ایجاد میکنیم .:(
              for (const itemField of item['fields']) {
                itemField['label'] = itemField.value;
                itemField['code'] = itemField.id;
                itemField['value'] = itemField.value;
              }
            }
          }
          const init = initializeConditionalFields(customRes);
          setFields(init || []);
          setTimeout(() => {
            setIsServiceChangeLoading(false);
          }, 10);
        })
        .catch((error) => {
          setIsServiceChangeLoading(false);
        });
    
  };

  /**
   * درخواست دسته بندی فروش
   */
  const getCategorySale = () => {
    setCategories([]);
    services
      .getTicketingSale()
      .then((res) => {
        let result = res?.result;
        setCategories((data) => data.concat(result));
        getCategorySupport();
      })
      .catch((error) => {
        setBaseLoading(false);
      });
  };

  /**
   * درخواست دسته بندی پشتیبانی
   */
  const getCategorySupport = () => {
    services
      .getTicketingSupport()
      .then((res) => {
        let result = res?.result;
        setCategories((data) => data.concat(result));
        setBaseLoading(false);
      })
      .catch((error) => {
        setBaseLoading(false);
      });
  };

  /**
   * اینجا بررسی میکند که تمامی فیلدهایی که سمت سرویس بک نیاز داریم به درستی پر شده باشد
   */
  const checkInput = () => {
    if (!selectedCategory) {
      createToast('خطا', 'لطفا فیلد بخش مربوطه را وارد نمایید.', 'danger');

      return false;
    }
    if (!selectedService) {
      createToast('خطا', 'لطفا فیلد نوع درخواست  را وارد نمایید.', 'danger');

      return false;
    }
    if (fields.length > 0) {
      for (const field of fields) {
        if (field.required && !field['selectedValue'] && !field['selectedValue'].trim()) {
          createToast('خطا', `لطفا فیلد ${field.persianName}  را وارد نمایید.`, 'danger');

          return false;
        }
      }
    }
    return true;
  };
  /**
   * ثبت نهایی فرم
   */
  const onSubmit = () => {
    const check = checkInput();
    if (!check) return;
    const values = methods.getValues();
    setSubmitLoading(true);
    const params = {};
    if (filesUpoaded.length > 0) {
      let arrFiles = [];
      for (const file of filesUpoaded) {
        arrFiles.push({
          Description: '',
          FileName: file.name,
          HashCode: file.hash,
        });
      }
      params.attachments = [...arrFiles];
    } else {
      params.attachments = [];
    }
    params.captchaId = captchaId;
    params.captchaAnswer = `${enteredCaptcha}`;
    params.description = values.description;
    params.name = values.name;
    params.requestTypeId = selectedService?.id;
    if (fields.length > 0) {
      const arr = [];
      for (const field of fields) {
        if (field['selectedValue'] && typeof field['selectedValue'] !== 'object') {
          // اگه ولیو آبجکت نباشد مثلا یک مقدار رشته یا عددی باشد
          arr.push({ Id: field.id, Value: field['selectedValue'] });
        } else {
          arr.push({ Id: field.id, Value: field['selectedValue']?.id });
        }
      }
      params.fields = [...arr];
    } else {
      params.fields = [];
    }
    const projectId = categories.find((a) => a.key == selectedCategory).projects[0]?.id; // پروژه آیدی، رو باید از کتگوری خونه صفرم و آیدی برداشت
    services
      .createTicket(selectedCategory, projectId, params)
      .then((res) => {
        createToast('موفق', 'درخواست با موفقیت ثبت شد.', 'success');
        setSubmitLoading(false);
        if (selectedCategory == 'support') {
          // پشتیبانی
          navigate('/Ticket/List/support');
        } else {
          // فروش
          navigate('/Ticket/List/sale');
        }
      })
      .catch((error) => {
        setSubmitLoading(false);
        captchaRef?.current?.onMakeCaptcha();
      });
  };

const handleFieldValueChange = (fieldId, newValue, fieldType = 'input') => {
  // ۱. منطق فیلدهای شرطی را اجرا می‌کند
  const updatedFields = handleFieldChange(fields, fieldId, newValue);

  // ۲. پیدا کردن فیلد تغییر کرده و ذخیره مقدار جدید در آن (بسیار مهم)
  const target = updatedFields.find((a) => a.id === fieldId);
  if (target) {
    target.selectedValue = newValue;
  }

  // ۳. آپدیت کردن استیت کل فیلدها
  setFields([...updatedFields]);
};


  return (
    <PageContainer
      title="ثبت درخواست پشتیبانی"
      breadcrumbs={constBreadCrumbsTitle.TICKET_CREATE}
      loading={baseLoading}
      meta={
        <>
          <Button
            color="primary"
            variant="outlined"
            endIcon={<Icons icon="CaretLeft" color="#2b3990" size="25" />}
            onClick={() => navigate('/Ticket/List/support')}
          >
            بازگشت به لیست تیکت ها
          </Button>
        </>
      }
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} noValidate autoComplete="off">
          <Grid container spacing={3}>
            <Grid
              direction="row"
              spacing={3}
              container
              item
              xs={12}
              md={12}
              lg={6}
              style={{ alignItems: 'center' }}
            >
              <Grid item md={12} xs={12}>
                <InputV2
                  fullWidth
                  errors={methods.formState.errors}
                  register={methods.register}
                  label="موضوع"
                  name="name"
                  rules={['required', 'isNotContainTag']}
                />
              </Grid>
              <Grid item md={6} xs={12} style={{ position: 'relative' }}>
                <span style={{ display: 'none' }}>
                  <InputV2
                    errors={methods.formState.errors}
                    register={methods.register}
                    control={methods.control}
                    name="category"
                    label="بخش مربوطه"
                    fullWidth
                    rules={['required']}
                    defaultValue={selectedCategory}
                    disabled={loadingSupport}
                    forceValue={selectedCategory}
                  />
                </span>
                <InputLabel shrink className={classes.label} style={{ display: 'flex' }}>
                  <span style={{ color: '#ef5350', margin: '0 4px' }}>*</span>
                  <LabelLine label="بخش مربوطه" />
                </InputLabel>
                <Select
                  fullWidth
                  value={selectedCategory}
                  onChange={(e) => {
                    onChangeCategory(e.target.value);
                    methods.setValue('category', e.target.value);
                    methods.clearErrors('category');
                    methods.setValue('service', '');
                  }}
                  variant="outlined"
                  required={true}
                  style={{ height: 38 }}
                  className={classes.pureSelect}
                  disabled={loadingSupport || isServiceChangeLoading}
                  id="cypress_select_category"
                >
                  {categories.map((item, index) => {
                    return <MenuItem value={item.key}>{item.title}</MenuItem>;
                  })}
                </Select>
                <span
                  style={{
                    position: 'absolute',
                    bottom: '-4px',
                    right: '12px',
                    color: 'red',
                    fontSize: '11px',
                  }}
                >
                  {methods?.errors?.category?.message}
                </span>
              </Grid>

              <Grid item xs={12} md={6} style={{ position: 'relative' }}>
                <AutocompleteV
                  control={methods.control}
                  errors={methods.formState.errors}
                  register={methods.register}
                  rules={['required']}
                  disabled={loadingSupport || isServiceChangeLoading}
                  name="service"
                  placeholder="جستجو و انتخاب کنید..."
                  label="نوع درخواست"
                  list={listServices}
                  forceValue={selectedService}
                  onChangeValue={(p) => {
                    onChangeService(p);
                  }}
                  preventAddCustomOption
                  disableClearable
                />
                {(loadingSupport || isServiceChangeLoading) && (
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress size={18} style={{ position: 'absolute', top: '55px' }} />
                  </div>
                )}
              </Grid>
            </Grid>

            <Grid
              direction="row"
              spacing={3}
              container
              item
              xs={12}
              md={12}
              lg={12}
              style={{ alignItems: 'flex-start' }}
            >
              {fields.length > 0 && (
                <GenerateField
                  fields={fields}
                  methods={methods}
                  handleFieldValueChange={handleFieldValueChange}
                />
              )}
            </Grid>
            <Grid
              direction="row"
              spacing={3}
              container
              item
              xs={12}
              md={12}
              lg={6}
              style={{ alignItems: 'center' }}
            >
              <Grid item xs={12}>
                <InputV2
                  label="پیام"
                  multiline
                  fullWidth
                  rows={5}
                  errors={methods.formState.errors}
                  name="description"
                  register={methods.register}
                  rules={['required', 'isNotContainTag']}
                />
              </Grid>
              <Grid md={12} xs={12} item>
                <div className={classes.fileUlpload}>
                  <UploadFiles
                    tooltip="فرمت فایل ارسالی به صورت jpg ,png ,pdf می‌باشد."
                    hasLink={true}
                    multiple={true}
                    setList={setFilesUpoaded}
                    type={'TICKETING'}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid md={12} xs={12} item>
              <Grid container>
                <InputV2
                  control={control}
                  register={register}
                  errors={errors}
                  name="captchaAnswer"
                  label="کد امنیتی"
                  forceValue={enteredCaptcha}
                  onChangeValue={(e) => {
                    const value = e.target.value;
                    if (value.length > 5) {
                      e.preventDefault();
                      setEnteredCaptcha(value.slice(0, 5));
                    } else {
                      setEnteredCaptcha(value);
                    }
                  }}
                  englishNumber
                  rules={['required', 'isNumeric']}
                  dir="ltr"
                />
                <CustomCaptchaComponent
                  ref={captchaRef}
                  setCaptchaId={setCaptchaId}
                  setEnteredCaptcha={setEnteredCaptcha}
                  pageTitle="ایجاد تیکت - /Ticket/Create"
                />
              </Grid>
            </Grid>
            <Grid direction="row" container item xs={12} justifyContent="flex-end">
              <ButtonLoading
                type="submit"
                variant="contained"
                color="primary"
                loading={submitLoading}
                disabled={submitLoading || isServiceChangeLoading}
                name="ثبت"
              />
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </PageContainer>
  );
};

export default CreateTicket;
